import { IconButtonProps, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const IconButtonStyled = styled(IconButton)<IconButtonProps>(({ theme }) => ({
  '&.MuiIconButton-root': {
    '&:active': {
      transform: 'scale(0.98)',
    },
  },
  '&.MuiIconButton-sizeLarge': {
    padding: theme.spacing(1),
  },
  '&.MuiIconButton-colorPrimary': {
    transition: 'background-color ease 0.4s',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,

    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  '&.MuiIconButton-colorSecondary': {
    transition: 'background-color ease 0.4s',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,

    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  '&.MuiIconButton-colorTertiary': {
    transition: 'background-color ease 0.4s',
    backgroundColor: theme.palette.tertiary.main,
    color: theme.palette.tertiary.contrastText,

    '&:hover': {
      backgroundColor: theme.palette.tertiary.dark,
    },
  },
}));
